import {registerPlugin} from '@capacitor/core';

export type AppPackageInfo = {firstInstalledAt: number; lastUpdatedAt: number; versionCode: number; versionName: string};
export const AppPackageInfoPlugin = registerPlugin<{getInfo(): Promise<AppPackageInfo>}>('AppPackageInfo');
